import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { withQueryParams } from "../helpers/common.js";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "date-fns";
import "date-fns/locale";
import "../appointment-details.types.js";
import "react/jsx-runtime";
import "axios";
const MIN_STRING_LENGTH_REQUIREMENT = 3;
const getPatientsList = (axios) => async (params) => {
  const { data } = await axios.get("/api/patient/search", {
    params
  });
  return (data == null ? void 0 : data.content) ?? [];
};
const usePatientSearch = ({ clinicReferenceId, query = "" }) => {
  const { patient, auth } = useAxiosProvider();
  const params = useMemo(
    () => ({
      clinicReferenceIds: clinicReferenceId,
      pageSize: 100,
      page: 0,
      query
    }),
    [clinicReferenceId, query]
  );
  const hasQuery = (query == null ? void 0 : query.length) >= MIN_STRING_LENGTH_REQUIREMENT;
  const queryKey = useMemo(() => ["patient-search", params], [params]);
  const enabled = !!clinicReferenceId && !!auth && hasQuery;
  const { data, ...queryResult } = useQuery({
    // @ts-expect-error TODO:
    queryKey,
    queryFn: withQueryParams(getPatientsList(patient)),
    keepPreviousData: true,
    enabled
  });
  return {
    queryKey,
    queryResult,
    data: hasQuery ? data : []
  };
};
export {
  MIN_STRING_LENGTH_REQUIREMENT,
  usePatientSearch
};
